// Къде стои елемент върху сцената в ПИКСЕЛИ (спрямо горния ляв ъгъл на
// видимото платно) — за котвите на поповъри, лентата над избрания елемент и т.н.

import type { SchemaElement } from "../../api/restaurantSchema";
import { elementHalfExtents } from "./geometry";

export type LogicalPoint = { x: number; y: number };

/** Правоъгълникът на елемента в пиксели на сцената (екранни оси, със столовете). */
export interface ElementBox {
  centerX: number;
  centerY: number;
  left: number;
  top: number;
  right: number;
  bottom: number;
  width: number;
  height: number;
}

/**
 * Пикселният правоъгълник на елемента, нарисуван в `position` (логическа —
 * записаната или тази, докато се влачи): завъртян, със столовете. `origin` —
 * къде в платното е логическата точка (0, 0).
 */
export const elementPixelBox = (
  element: SchemaElement,
  position: LogicalPoint,
  scale: number,
  origin: { left: number; top: number } = { left: 0, top: 0 },
): ElementBox => {
  const { halfWidth, halfHeight } = elementHalfExtents(element);
  const centerX = origin.left + position.x * scale;
  const centerY = origin.top + position.y * scale;
  return {
    centerX,
    centerY,
    left: centerX - halfWidth * scale,
    top: centerY - halfHeight * scale,
    right: centerX + halfWidth * scale,
    bottom: centerY + halfHeight * scale,
    width: halfWidth * 2 * scale,
    height: halfHeight * 2 * scale,
  };
};

// Слоят на всеки вид (по-голям = по-отгоре): стените най-отдолу, после
// едрите непрозрачни обекти, растенията/входът, и масите най-отгоре — иначе
// по-късно създаден бар/сцена скрива маса под себе си и тя не се хваща.
const PAINT_LAYER: Record<SchemaElement["kind"], number> = {
  wall: 0,
  stage: 1,
  bar: 1,
  dj: 1,
  plant: 2,
  entrance: 2,
  table: 3,
};

/** Елементите в реда на рисуване (по слой; в един слой — по реда от BE). */
export const elementsInPaintOrder = (elements: SchemaElement[]) =>
  [...elements].sort((first, second) => PAINT_LAYER[first.kind] - PAINT_LAYER[second.kind]);
